/**
 * Remember-email helpers backed by localStorage. Mirrors Flutter
 * MD3-Admin's rememberEmail/saved_email behaviour but client-side only —
 * the BFF doesn't know or care about this preference.
 *
 * All three helpers are SSR-safe (no-op when window is absent) and
 * swallow localStorage errors so the login flow is never blocked by a
 * storage hiccup (full quota, incognito-strict, etc).
 */

const KEY = "md3_adm_saved_email";

const hasWindow = (): boolean => typeof window !== "undefined";
const isLikelyEmail = (s: string): boolean =>
  s.length > 0 && s.length < 256 && s.includes("@");

export function readRememberedEmail(): string | null {
  if (!hasWindow()) return null;
  try {
    const v = window.localStorage.getItem(KEY);
    if (typeof v !== "string") return null;
    if (!isLikelyEmail(v)) return null;
    return v;
  } catch {
    return null;
  }
}

export function saveRememberedEmail(email: string): void {
  if (!hasWindow()) return;
  if (!isLikelyEmail(email)) return;
  try {
    window.localStorage.setItem(KEY, email);
  } catch {
    // localStorage may throw on quota / disabled — non-fatal.
  }
}

export function clearRememberedEmail(): void {
  if (!hasWindow()) return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // non-fatal
  }
}
